import { useCallback } from "react";
import { RootState } from "../store";
import * as UsuarioActions from "../store/Usuario.reducer";
import { useAppDispatch, useAppSelector } from "./hooks";

export default function useUsuario() {
  const dispatch = useAppDispatch();

  const usuarios = useAppSelector((state: RootState) => state.usuario.list);

  const usuario = useAppSelector((state: RootState) => state.usuario.usuario);

  const buscarUsuarios = useCallback(() => {
    dispatch(UsuarioActions.getUsuarios());
  }, [dispatch]);

  const buscarUsuario = useCallback(
    (objeto: any) => {
      dispatch(UsuarioActions.getUsuario(objeto));
    },
    [dispatch]
  );

    const getUser = useCallback(
    () => {
      dispatch(UsuarioActions.getUser());
    },
    [dispatch]
  );

  const setUser = useCallback(
    (objeto: any) => {
      dispatch(UsuarioActions.setUser(objeto));
    },
    [dispatch]
  );  

  return {
    buscarUsuarios,
    buscarUsuario,
    getUser,
    setUser,
    usuarios,
    usuario,
  };
}
